import { render, staticRenderFns } from "./ProjectAssign.vue?vue&type=template&id=02c0a290"
import script from "./ProjectAssign.vue?vue&type=script&lang=js"
export * from "./ProjectAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports